module.exports = __webpack_public_path__ + "img/05-agreement.e99ee311.png";